module.exports = __webpack_public_path__ + "static/media/red.22220b2d.svg";